var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc-container"},[_vm._m(0),_c('div',{ref:"myChart",staticClass:"tp-chart"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-bgfh"},[_c('div',[_vm._v("本月")]),_c('div',[_vm._v("上月")]),_c('div',[_vm._v("去年同期")])])
}]

export { render, staticRenderFns }